/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { decisioningStudioAgentsAppGroupId } from "./constants";
import type { DecisioningStudioAgentsAppGroupIdParams, GetDecisioningStudioAgentsAppGroupIdResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdResult } from "./validators";

export const getDataTableDecisioningStudioAgentsAppGroupId = reactQueryTableFetcherAdapter(
  decisioningStudioAgentsAppGroupId,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: DecisioningStudioAgentsAppGroupIdParams
  ): Promise<GetDecisioningStudioAgentsAppGroupIdResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdResult
);
